const courses = [
  "Secondary Examination(10th Class)",
  "SR. Secondary Examination(12th Class)",
];
export default courses;
